<div>
  {{ 'page.error.404.title' | translate }}
</div>
